import { useEffect, useState } from "react";

import { useChartSettings } from "../context/ChartSettingsContext";

// This hook updates the dashboard title to be italicized if settings or presets
// are modified
//
// `enabled` is off for a chart that is not a widget - the well card's, which
// carries its own settings and is saved with nothing. Such an instance still
// runs the hook, so the comparison below keeps up and one later flip cannot
// report every change made since the card opened.
const useChartStateForDashboard = (dashboardDispatch, enabled = true) => {
  const [lastSettings, setLastSettings] = useState<string>();
  const [chartSettings] = useChartSettings();

  useEffect(() => {
    // properties that can be changed by user
    const { currentPreset, settings, storedPreset } = chartSettings;
    const nextSettings = JSON.stringify({ currentPreset, settings, storedPreset });
    if (!lastSettings) {
      setLastSettings(nextSettings);
    } else if (nextSettings !== lastSettings) {
      if (enabled) {
        dashboardDispatch({ payload: { hasModifiedWidgets: true } });
      }
      setLastSettings(nextSettings);
    }
  }, [chartSettings, lastSettings, dashboardDispatch, enabled]);
};

export default useChartStateForDashboard;
